var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.7786,
    cy: 45.7786,
    r: 44.5668,
    stroke: "#E37B00",
    strokeWidth: 2.42357
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.7786,
    cy: 45.7791,
    r: 43.0857,
    fill: "#C6CEDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6606 36.0744C33.6653 35.4122 34.2006 34.8764 34.8627 34.8711H56.6943C57.3583 34.8711 57.8963 35.4103 57.8963 36.0744V55.4799C57.8917 56.1421 57.3564 56.678 56.6943 56.6832H34.8627C34.1987 56.6826 33.6606 56.144 33.6606 55.4799V36.0744ZM55.4729 37.2947H36.0844V54.2597L47.3443 42.9973C47.8175 42.5243 48.5845 42.5243 49.0577 42.9973L55.4729 49.4247V37.2947ZM38.5076 42.1418C38.5076 43.4803 39.5927 44.5653 40.9312 44.5653C42.2697 44.5653 43.3548 43.4803 43.3548 42.1418C43.3548 40.8033 42.2697 39.7182 40.9312 39.7182C39.5927 39.7182 38.5076 40.8033 38.5076 42.1418Z",
    fill: "#E8EBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.a37e4847e3d3cec91250aff300e00797.svg";
export { ForwardRef as ReactComponent };